import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Menu } from '@material-ui/core';
import StepSidebar from './StepSidebar';
import StepMenu from './StepMenu';

class StepsMenu extends Component {
  render() {
    return this.props.anchorEl ? (
      <Menu
        open={true}
        onClose={this.props.onClose}
        anchorEl={this.props.anchorEl}
      >
        {this.props.steps.map((step, index) => {
          return (
            <StepMenu
              {...step}
              key={index}
              onClick={(event) => {
                step.onClick(event);
                this.props.onClose();
              }}
            />
          );
        })}
      </Menu>
    ) : null;
  }
}

StepsMenu.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.exact(StepSidebar.propTypes).isRequired)
    .isRequired,
  onClose: PropTypes.func.isRequired,
  anchorEl: PropTypes.object,
};

export default StepsMenu;
